import { Fragment } from "react";
import WishRequestCard from "../../../../components/Cards/WishRequest";
import { ReactComponent as EmptyIcon } from '../../../../assets/images/icons/empty.svg';
import { useTranslation } from "react-i18next";

function ActiveTab({requests, refresh}) {
  const { t } = useTranslation('wishlist');

  return(
    <Fragment>
      {requests?.length > 0 ?
        requests.map((data, key) => {
          return(
            <WishRequestCard wish={data} key={key} refresh={refresh} />
          );
        })
      :
        <div className="text-center mt-4">
          <EmptyIcon />

          <h6 className="mt-4 fw-normal text-muted">{t("empty")}</h6>
        </div>
      }
    </Fragment>
  );
}

export default ActiveTab;